import { Link } from "react-router-dom";

export default function ExploreSection() {
  return (
    <section className="cards">
      <div className="card__swiper swiper-container">
        <ul className="card__slider swiper-wrapper">
          <li className="card__item card__item--cyan swiper-slide">
            <h3 className="card__title">Tendance</h3>
            <p className="card__description">
              Trouvez les personnes qui ont le plus besoin de votre aide
            </p>
            <Link className="card__link" to="/search">
              Voir la tendance
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30.296"
                height="14.884"
                viewBox="0 0 30.296 14.884"
              >
                <path
                  id="Shape"
                  d="M19.653,8.852c-.05-.622-.149-1.339,0-1.388a15.881,15.881,0,0,1,2.977-.717C15.087,5.55,7.543,4.4.049,3.253c-.148,0,.1-2.51,0-2.536C8.288,1.962,16.577,3.254,24.815,4.546c-.745-.671-1.539-1.292-2.283-1.962-.148-.144,0-1.1,0-1.292S22.68.143,22.531,0L27,3.875c.4.335.794.718,1.192,1.053.248.239.644.43.744.814a9.529,9.529,0,0,1,0,2.057v.478c0-.048-.049-.048-.049-.1-.1.335-.347.383-.894.479-.943.191-1.886.239-2.829.335a21.5,21.5,0,0,0-4.964.813.048.048,0,0,1-.049.049c-.149.048-.347.1-.5.143ZM.049.717h0Z"
                  transform="matrix(0.985, -0.174, 0.174, 0.985, 0, 5.036)"
                  fill="#6FB0E1"
                ></path>
              </svg>
            </Link>
          </li>
          <li className="card__item card__item--orange swiper-slide">
            <h3 className="card__title whitespace-nowrap">Les plus récents</h3>
            <p className="card__description">
              Naviguez parmi les plus récents 3awenis{" "}
            </p>
            <Link className="card__link" to="/discover/animals">
              Voir
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30.296"
                height="14.884"
                viewBox="0 0 30.296 14.884"
              >
                <path
                  id="Shape"
                  d="M19.653,8.852c-.05-.622-.149-1.339,0-1.388a15.881,15.881,0,0,1,2.977-.717C15.087,5.55,7.543,4.4.049,3.253c-.148,0,.1-2.51,0-2.536C8.288,1.962,16.577,3.254,24.815,4.546c-.745-.671-1.539-1.292-2.283-1.962-.148-.144,0-1.1,0-1.292S22.68.143,22.531,0L27,3.875c.4.335.794.718,1.192,1.053.248.239.644.43.744.814a9.529,9.529,0,0,1,0,2.057v.478c0-.048-.049-.048-.049-.1-.1.335-.347.383-.894.479-.943.191-1.886.239-2.829.335a21.5,21.5,0,0,0-4.964.813.048.048,0,0,1-.049.049c-.149.048-.347.1-.5.143ZM.049.717h0Z"
                  transform="matrix(0.985, -0.174, 0.174, 0.985, 0, 5.036)"
                  fill="#F49440"
                ></path>
              </svg>
            </Link>
          </li>
          <li className="card__item card__item--red swiper-slide">
            <h3 className="card__title">Près de vous</h3>
            <p className="card__description">
              Trouvez les personnes les plus proches de vous qui ont besoin
              d'aide.
            </p>
            <Link className="card__link" to="/search">
              Tell Me More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30.296"
                height="14.884"
                viewBox="0 0 30.296 14.884"
              >
                <path
                  id="Shape"
                  d="M19.653,8.852c-.05-.622-.149-1.339,0-1.388a15.881,15.881,0,0,1,2.977-.717C15.087,5.55,7.543,4.4.049,3.253c-.148,0,.1-2.51,0-2.536C8.288,1.962,16.577,3.254,24.815,4.546c-.745-.671-1.539-1.292-2.283-1.962-.148-.144,0-1.1,0-1.292S22.68.143,22.531,0L27,3.875c.4.335.794.718,1.192,1.053.248.239.644.43.744.814a9.529,9.529,0,0,1,0,2.057v.478c0-.048-.049-.048-.049-.1-.1.335-.347.383-.894.479-.943.191-1.886.239-2.829.335a21.5,21.5,0,0,0-4.964.813.048.048,0,0,1-.049.049c-.149.048-.347.1-.5.143ZM.049.717h0Z"
                  transform="matrix(0.985, -0.174, 0.174, 0.985, 0, 5.036)"
                  fill="#FF4032"
                ></path>
              </svg>
            </Link>
          </li>
          <li className="card__item card__item--blue swiper-slide">
            <h3 className="card__title">Naviguez les 3aweni</h3>
            <p className="card__description">
              Effectuez une recherche selon votre choix.
            </p>
            <Link className="card__link" to="/search">
              Rechercher
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30.296"
                height="14.884"
                viewBox="0 0 30.296 14.884"
              >
                <path
                  id="Shape"
                  d="M19.653,8.852c-.05-.622-.149-1.339,0-1.388a15.881,15.881,0,0,1,2.977-.717C15.087,5.55,7.543,4.4.049,3.253c-.148,0,.1-2.51,0-2.536C8.288,1.962,16.577,3.254,24.815,4.546c-.745-.671-1.539-1.292-2.283-1.962-.148-.144,0-1.1,0-1.292S22.68.143,22.531,0L27,3.875c.4.335.794.718,1.192,1.053.248.239.644.43.744.814a9.529,9.529,0,0,1,0,2.057v.478c0-.048-.049-.048-.049-.1-.1.335-.347.383-.894.479-.943.191-1.886.239-2.829.335a21.5,21.5,0,0,0-4.964.813.048.048,0,0,1-.049.049c-.149.048-.347.1-.5.143ZM.049.717h0Z"
                  transform="matrix(0.985, -0.174, 0.174, 0.985, 0, 5.036)"
                  fill="#017289"
                ></path>
              </svg>
            </Link>
          </li>
        </ul>
      </div>
    </section>
  );
}
